import { create } from 'zustand';
import { setCookie } from 'cookies-next';

interface UiState {
  isMobile: boolean;
}

interface UiActions {
  setMobileCookie: (isMobile: boolean) => void;
}

type UiStore = UiState & UiActions;

export const useUiStore = create<UiStore>((set) => ({
  isMobile: false,

  setMobileCookie: (isMobile) => {
    setCookie('isMobile', isMobile, {
      maxAge: 7 * 24 * 60 * 60,
      path: '/',
      domain: process.env.NEXT_PUBLIC_ROOT_DOMAIN || '.zangia.local',
      sameSite: 'lax',
    });
    set({ isMobile });
  },
}));

export const setMobileCookie = (isMobile: boolean) =>
  useUiStore.getState().setMobileCookie(isMobile);
